
import Vue from 'vue';
import { Component, Provide } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { initClient } from '../../../api';
import { PqtConfig, PqtGroupType, PqtGroupTypeAPIControllerUIClient, PqtProduct, SettingsApiControllerUIClient } from '../../backend/backendapi';
import { RiskOption, RiskOptionSetting } from '../archivemodal/archivemodal.model';
import PqtList from '../list/PqtList';
import State from '../State';
import MeasurementSpecificationTemplates from '../measurementSpecificationTemplates/MeasurementSpecificationTemplates';
import moment from 'moment';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    MeasurementSpecificationTemplates,
    PqtList,
    Abstract: require('../abstract/abstract.vue.html').default,
  },
})
export default class PqtMain extends Vue {
  currentTab: number = 0;

  @Provide('state')
  readonly state = new State();

  unarchivedFunction = 'archived = false';
  archivedFunction = 'archived = true';

  editProduct: PqtProduct = new PqtProduct();

  private readonly groupAPI = initClient(PqtGroupTypeAPIControllerUIClient);
  private readonly settingsApi = initClient(SettingsApiControllerUIClient);

  get GroupTypeInstanciator(): any {
    return (init?) => new PqtGroupType(init);
  }

  mounted(): void {
    this.reloadAll();
  }

  async reloadAll(): Promise<void> {
    await this.state.groupsStore.reload();
    await this.reloadConfig();
    await this.reloadRiskOptions(); //reload this first
  }

  async reloadConfig(): Promise<void> {
    try {
      this.state.config = (await this.settingsApi.getSystemSetting('productQualityTests.config')).result!;
    } catch (e) {
      console.error('Failed to load config', e);
      this.state.config = new PqtConfig();
    }
  }

  async reloadRiskOptions(): Promise<void> {
    let obj = (await this.settingsApi.getSystemSetting('productQualityTests.riskoptions')).result!;
    let set = new RiskOptionSetting();
    Object.keys(obj).forEach(lang => {
      let options: RiskOption[] = [];
      set[lang] = options;
      Object.keys(obj[lang]).forEach(id => {
        options.push({ id: id, name: obj[lang][id] } as RiskOption);
      });
    });
    this.state.riskOptionsSetting = set;
  }
}
